module.exports = __webpack_public_path__ + "static/img/1_1.11587c96.jpg";